import styled, { css } from 'styled-components';

export const Container = styled.div`
    display: block;
    color: #898989;
    transition: all 0.33s ease-in-out;
    visibility: visible;
    background-image: none;
`;

type WrapperProps = { $minHeight: number; $relative?: boolean };

export const Wrapper = styled.div.attrs<WrapperProps>(({ $minHeight }) => ({
    style: {
        minHeight: $minHeight,
    },
}))<WrapperProps>`
    ${({ $relative }) =>
        $relative &&
        css`
            position: relative;
        `}
`;

type ImageProps = { $minHeight: number; $backgroundImage: string; $withoutLogo: boolean };

export const Image = styled.img.attrs<ImageProps>(({ $backgroundImage, $minHeight }) => ({
    style: {
        minHeight: $minHeight,
        backgroundImage: `url(${$backgroundImage})`,
    },
}))<ImageProps>`
    width: 100%;
    display: block;
    margin: 0;
    padding: 0;
    background-repeat: no-repeat;
    background-position: top left;
    background-size: cover;
    position: relative;

    ${({ $withoutLogo }) =>
        $withoutLogo &&
        css`
            &:before {
                content: ' ';
                background: linear-gradient(
                    180deg,
                    rgba(0, 0, 0, 0.03) 31.74%,
                    rgba(0, 0, 0, 0.3) 90%
                );
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 1;
            }
        `};
`;

export const Label = styled.div`
    position: absolute;
    width: 100%;
    bottom: 0;
    z-index: 2;
`;

export const TitleLabel = styled.div<{ $withDeliveryLabel: boolean }>`
    position: absolute;
    bottom: 134px;
    left: 0;
    width: 100%;
    text-align: center;
    color: ${({ theme }) => theme.functionColor.function0};
    font-weight: 700;
    font-size: 20px;
    z-index: 1;

    ${({ $withDeliveryLabel }) =>
        $withDeliveryLabel &&
        css`
            bottom: 150px;
        `}
`;
